var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.45 453.45 93.59 453.2 145.73 453.12 250 452.95 354.27 453.12 406.41 453.2 458.55 453.45 406.41 453.69 354.27 453.78 250 453.95 145.73 453.78 93.59 453.69 41.45 453.45",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.51,70.6h-169A17.26,17.26,0,0,0,148.36,88V436a17.27,17.27,0,0,0,17.11,17.42h169A17.29,17.29,0,0,0,351.64,436V88A17.28,17.28,0,0,0,334.51,70.6Zm6.43,354.67c0,9.16-6.86,16.57-15.31,16.57H174.39c-8.49,0-15.34-7.41-15.34-16.57V101.21c0-18.66,6.85-19.57,15.34-19.57h30.29c1.76,0,3.2,2,3.2,4.48v1.07C207.88,93,211.06,93,215,93h70c4,0,7.09,0,7.09-5.83V86.12c0-2.48,1.42-4.48,3.22-4.48h30.3c8.45,0,15.31,2.48,15.31,19.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.55,85.76H240.44a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h19.11a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.55,85.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,101.21V425.27c0,9.16-6.86,16.57-15.32,16.57H174.39c-8.48,0-15.34-7.41-15.34-16.57V101.21c0-18.66,6.86-19.57,15.34-19.57h30.29c1.76,0,3.2,2,3.2,4.48v1.07C207.88,93,211.06,93,215,93H285c3.94,0,7.09,0,7.09-5.83V86.12c0-2.48,1.42-4.48,3.21-4.48h30.3C334.09,81.64,341,84.12,341,101.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.46 122.84 172.08 117.81 177.46 112.77 178.29 113.66 173.87 117.81 178.29 121.95 177.46 122.84",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,114.67a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,326.86,114.67Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,118.43a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,326.86,118.43Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,122.19a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,326.86,122.19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,121a.37.37,0,0,1,.51,0,2.2,2.2,0,0,0,1.34.54,1.47,1.47,0,0,0,.87-.26.62.62,0,0,0,.3-.5.4.4,0,0,0-.06-.22.69.69,0,0,0-.21-.21,2.54,2.54,0,0,0-1-.33h0a4.12,4.12,0,0,1-.9-.28,1.44,1.44,0,0,1-.65-.54,1.06,1.06,0,0,1-.16-.58,1.3,1.3,0,0,1,.56-1,2.07,2.07,0,0,1,1.21-.37,2.78,2.78,0,0,1,1.53.56.36.36,0,1,1-.4.6,2,2,0,0,0-1.13-.45,1.34,1.34,0,0,0-.78.24.57.57,0,0,0-.27.44.31.31,0,0,0,.05.2.66.66,0,0,0,.19.18,2.35,2.35,0,0,0,.87.31h0a4.17,4.17,0,0,1,1,.29,1.67,1.67,0,0,1,.7.58,1.11,1.11,0,0,1,.17.6,1.37,1.37,0,0,1-.6,1.09,2.19,2.19,0,0,1-1.29.39,3,3,0,0,1-1.8-.7A.37.37,0,0,1,235.69,121Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,117.67a.38.38,0,0,1,.38-.38.4.4,0,0,1,.4.38v4.14a.4.4,0,0,1-.4.38.38.38,0,0,1-.38-.38Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,119.68a2.55,2.55,0,0,1,2.58-2.53,2.62,2.62,0,0,1,1.6.54.4.4,0,0,1,.07.57.4.4,0,0,1-.56.07,1.81,1.81,0,0,0-2.37.13,1.65,1.65,0,0,0,0,2.42,1.76,1.76,0,0,0,1.26.51,1.94,1.94,0,0,0,1-.26v-1h-1a.4.4,0,0,1-.4-.4.39.39,0,0,1,.4-.39h1.39a.39.39,0,0,1,.41.39v1.55s0,.07,0,.12l0,0h0a.34.34,0,0,1-.13.17,2.59,2.59,0,0,1-1.59.54A2.54,2.54,0,0,1,242.43,119.68Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.11,121.81a.38.38,0,0,1-.76,0v-4.07h0a.37.37,0,0,1,.15-.32.39.39,0,0,1,.54.08l2.26,3.13v-2.88a.38.38,0,0,1,.76,0v4.07a.38.38,0,0,1-.38.38.36.36,0,0,1-.29-.14l0,0-2.24-3.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,122.19a2,2,0,0,1-2-2v-2.5a.37.37,0,0,1,.38-.38.39.39,0,0,1,.39.38v2.5a1.25,1.25,0,0,0,2.5,0v-2.5a.38.38,0,0,1,.39-.38.37.37,0,0,1,.38.38v2.5A2,2,0,0,1,257.87,122.19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.17,120.29h-.86v1.52a.39.39,0,0,1-.77,0v-4.14a.38.38,0,0,1,.38-.38h1.25a1.5,1.5,0,1,1,0,3Zm-.86-.78h.86a.72.72,0,1,0,0-1.44h-.86Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.45,88.92l-.29.29-.17.16a4,4,0,0,0-5.64,0l-.16-.17-.29-.29h0l0,0,.37-.33a5.16,5.16,0,0,1,.86-.54,4.14,4.14,0,0,1,1.14-.38c.18,0,.37,0,.56-.08h.5l.39,0a4.77,4.77,0,0,1,1,.25,4.94,4.94,0,0,1,.7.33,4.48,4.48,0,0,1,.67.47l.31.28Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.28,90.29l-.47-.46a3.35,3.35,0,0,1,4.72,0l-.47.46a2.68,2.68,0,0,0-3.78,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,90.76l-.46.46a1.35,1.35,0,0,0-1.94,0c-.15-.16-.31-.31-.46-.46A2,2,0,0,1,197.6,90.76Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.59,91.63a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,196.59,91.63Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.91,89.8a1.21,1.21,0,1,1,1.2,1.21A1.2,1.2,0,0,1,170.91,89.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7,89.8A1.21,1.21,0,1,1,175.91,91,1.21,1.21,0,0,1,174.7,89.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,89.8A1.21,1.21,0,1,1,179.71,91,1.21,1.21,0,0,1,178.5,89.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,89.8A1.21,1.21,0,1,1,183.5,91,1.2,1.2,0,0,1,182.3,89.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,89.8A1.21,1.21,0,1,1,187.3,91,1.2,1.2,0,0,1,186.1,89.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,92.44h-9.83V87.88h9.83ZM318,91.93h8.8V88.39H318Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 88.66,
    width: 6.33,
    height: 3,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.31,
    y: 88.94,
    width: 0.87,
    height: 2.43,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.22 424.33 181.33 424.33 181.33 428.41 179.67 428.41 179.67 426.33 176.73 426.33 176.73 428.41 175.06 428.41 175.06 424.33 174.18 424.33 178.2 420.18 182.22 424.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.51,
    y: 420.18,
    width: 9.69,
    height: 1.38,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.51,
    y: 423.6,
    width: 9.69,
    height: 1.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.51,
    y: 427.03,
    width: 9.69,
    height: 1.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.04 424.44 250.28 427.38 247.53 424.44 248.01 423.98 250.28 426.4 252.55 423.98 253.04 424.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,430.42a5,5,0,1,1,5-5A5,5,0,0,1,250.28,430.42Zm0-9.35a4.35,4.35,0,1,0,4.35,4.34A4.34,4.34,0,0,0,250.28,421.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,213.29a1.94,1.94,0,0,1-1.94-1.94V209a.38.38,0,0,1,.75,0v2.39a1.2,1.2,0,0,0,2.39,0V209a.37.37,0,0,1,.38-.37.36.36,0,0,1,.36.37v2.39A1.94,1.94,0,0,1,192.49,213.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,212.33a.34.34,0,0,1,.5-.05,1.28,1.28,0,0,0,.74.29.89.89,0,0,0,.46-.13c.09-.08.12-.14.12-.2a.11.11,0,0,0,0-.06s0-.05-.09-.09a1.67,1.67,0,0,0-.54-.18h0a2.79,2.79,0,0,1-.58-.18,1.15,1.15,0,0,1-.46-.39.76.76,0,0,1-.12-.42,1,1,0,0,1,.4-.74,1.45,1.45,0,0,1,.83-.25,1.68,1.68,0,0,1,1,.37.38.38,0,0,1,.11.5.35.35,0,0,1-.5.09,1.14,1.14,0,0,0-.61-.25.69.69,0,0,0-.41.13.21.21,0,0,0-.1.15.07.07,0,0,0,0,.05l.07.07a1.38,1.38,0,0,0,.49.16h0a2.49,2.49,0,0,1,.62.19,1.08,1.08,0,0,1,.48.4.86.86,0,0,1,.12.44,1,1,0,0,1-.42.78,1.5,1.5,0,0,1-.87.27,2,2,0,0,1-1.2-.46A.37.37,0,0,1,195.78,212.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,211.61a1.65,1.65,0,0,1,1.63-1.68,1.6,1.6,0,0,1,1.62,1.56v0s0,0,0,.06a.31.31,0,0,1-.34.27h-2.14a.88.88,0,0,0,.23.45,1,1,0,0,0,.64.3,1.08,1.08,0,0,0,.7-.17.38.38,0,0,1,.51,0,.32.32,0,0,1,0,.44,1.72,1.72,0,0,1-1.21.44A1.66,1.66,0,0,1,199,211.61Zm.73-.33h1.9a1.1,1.1,0,0,0-1-.71A.93.93,0,0,0,199.74,211.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.26,210.29a.36.36,0,0,1-.36.35.62.62,0,0,0-.4.13,1,1,0,0,0-.31.32,2.38,2.38,0,0,0-.28.57v1.27a.36.36,0,0,1-.37.36.36.36,0,0,1-.35-.36v-2.64a.35.35,0,0,1,.35-.35.35.35,0,0,1,.37.35v.05a.92.92,0,0,1,.14-.14,1.45,1.45,0,0,1,.85-.26A.35.35,0,0,1,205.26,210.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.93,211.33v1.6a.35.35,0,0,1-.34.36.36.36,0,0,1-.36-.36v-1.6a.69.69,0,0,0-.7-.68.67.67,0,0,0-.67.68v1.6a.2.2,0,0,1,0,.07.38.38,0,0,1-.36.29.35.35,0,0,1-.35-.36v-2.64a.35.35,0,0,1,.35-.36.36.36,0,0,1,.33.21,1.32,1.32,0,0,1,.71-.21A1.4,1.4,0,0,1,208.93,211.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,211.62v1.31a.35.35,0,0,1-.7.07,1.56,1.56,0,0,1-.9.29,1.58,1.58,0,0,1-1.14-.49,1.73,1.73,0,0,1-.46-1.18,1.67,1.67,0,0,1,.46-1.18,1.52,1.52,0,0,1,2-.21.35.35,0,0,1,.7.07Zm-.71,0a1,1,0,0,0-.26-.69.84.84,0,0,0-.63-.28.8.8,0,0,0-.62.28,1,1,0,0,0-.26.69,1,1,0,0,0,.26.69.82.82,0,0,0,.62.26.86.86,0,0,0,.63-.26A1,1,0,0,0,212.38,211.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,211.32v1.61a.36.36,0,0,1-.35.36.37.37,0,0,1-.37-.36v-1.61a.68.68,0,0,0-.69-.67.69.69,0,0,0-.68.69V213s0,0,0,0v0a.39.39,0,0,1-.34.22h-.07a.36.36,0,0,1-.28-.35v-1.59h0v-1a.36.36,0,0,1,.35-.37.35.35,0,0,1,.32.2,1.53,1.53,0,0,1,.72-.2,1.4,1.4,0,0,1,1.06.47,1.37,1.37,0,0,1,1-.47,1.41,1.41,0,0,1,1.4,1.41v1.59a.36.36,0,0,1-.36.36.36.36,0,0,1-.36-.36v-1.59a.69.69,0,0,0-.68-.69A.7.7,0,0,0,217.21,211.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.55,211.61a1.67,1.67,0,0,1,1.64-1.68,1.6,1.6,0,0,1,1.62,1.56v0s0,0,0,.06a.31.31,0,0,1-.34.27h-2.14a.88.88,0,0,0,.23.45,1,1,0,0,0,.64.3,1.1,1.1,0,0,0,.7-.17.38.38,0,0,1,.51,0,.32.32,0,0,1,0,.44,1.72,1.72,0,0,1-1.21.44A1.68,1.68,0,0,1,220.55,211.61Zm.74-.33h1.9a1.1,1.1,0,0,0-1-.71A.93.93,0,0,0,221.29,211.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.42,
    y: 218.41,
    width: 121.16,
    height: 14.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.55,247.41v-4a.36.36,0,0,1,.37-.37h2.19a.37.37,0,0,1,.37.37.38.38,0,0,1-.37.38h-1.82v1.22h1.57a.38.38,0,0,1,.37.37.38.38,0,0,1-.37.38h-1.57V247h1.82a.38.38,0,0,1,0,.75h-2.19A.37.37,0,0,1,190.55,247.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,245.81v1.61a.36.36,0,0,1-.35.36.37.37,0,0,1-.37-.36v-1.61a.68.68,0,0,0-.69-.67.69.69,0,0,0-.68.69v1.66s0,0,0,0v0a.39.39,0,0,1-.34.22h-.07a.36.36,0,0,1-.29-.35v-1.59h0v-1a.37.37,0,0,1,.36-.37.35.35,0,0,1,.32.2,1.53,1.53,0,0,1,.72-.2,1.42,1.42,0,0,1,1.06.47,1.37,1.37,0,0,1,1.05-.47,1.41,1.41,0,0,1,1.4,1.41v1.59a.36.36,0,0,1-.72,0v-1.59a.69.69,0,0,0-.68-.69A.7.7,0,0,0,197.26,245.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68,246.11v1.31a.36.36,0,0,1-.36.36.37.37,0,0,1-.35-.29,1.5,1.5,0,0,1-.89.29,1.56,1.56,0,0,1-1.14-.49,1.73,1.73,0,0,1-.46-1.18,1.69,1.69,0,0,1,.46-1.18,1.54,1.54,0,0,1,1.14-.51,1.51,1.51,0,0,1,.89.3.37.37,0,0,1,.35-.3.36.36,0,0,1,.36.37Zm-.71,0a.94.94,0,0,0-.27-.69.82.82,0,0,0-.62-.28.8.8,0,0,0-.62.28.94.94,0,0,0-.26.69,1,1,0,0,0,.26.69.82.82,0,0,0,.62.26.84.84,0,0,0,.62-.26A1,1,0,0,0,203,246.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.73,243.58a.37.37,0,1,1-.73,0v-.14a.37.37,0,0,1,.73,0Zm0,1.22v2.62a.37.37,0,0,1-.73,0V244.8a.37.37,0,1,1,.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.16,243.08a.38.38,0,0,1,.37.37v4a.38.38,0,0,1-.37.37.37.37,0,0,1-.37-.37v-4A.37.37,0,0,1,207.16,243.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.42,
    y: 252.9,
    width: 121.16,
    height: 14.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12,280.44h-.83v1.46a.37.37,0,0,1-.37.37.38.38,0,0,1-.37-.37v-4a.37.37,0,0,1,.37-.37h1.2a1.44,1.44,0,1,1,0,2.87Zm-.83-.74h.83a.69.69,0,1,0,0-1.38h-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,280.6v1.32a.36.36,0,0,1-.36.35.37.37,0,0,1-.35-.29,1.53,1.53,0,0,1-.89.29,1.56,1.56,0,0,1-1.14-.49,1.71,1.71,0,0,1-.46-1.18,1.69,1.69,0,0,1,.46-1.18,1.5,1.5,0,0,1,2-.21.37.37,0,0,1,.35-.3.37.37,0,0,1,.36.37Zm-.71,0a1,1,0,0,0-.27-.69.84.84,0,0,0-1.25,0,1,1,0,0,0-.25.69,1,1,0,0,0,.25.69.88.88,0,0,0,1.25,0A1,1,0,0,0,196.52,280.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.38,281.31a.34.34,0,0,1,.5-.05,1.28,1.28,0,0,0,.74.29.89.89,0,0,0,.46-.13c.09-.08.12-.14.12-.2a.11.11,0,0,0,0-.06.18.18,0,0,0-.09-.08,1.31,1.31,0,0,0-.53-.19h0a2.46,2.46,0,0,1-.58-.18,1,1,0,0,1-.47-.39.85.85,0,0,1-.11-.42,1,1,0,0,1,.39-.74,1.48,1.48,0,0,1,.83-.25,1.74,1.74,0,0,1,1,.37.37.37,0,0,1,.1.5.34.34,0,0,1-.49.09,1.18,1.18,0,0,0-.62-.24.63.63,0,0,0-.4.12c-.09.06-.11.12-.11.15a.07.07,0,0,0,0,.05.19.19,0,0,0,.08.07,1.31,1.31,0,0,0,.49.16h0a2.49,2.49,0,0,1,.62.19,1,1,0,0,1,.48.4.87.87,0,0,1,.13.44,1,1,0,0,1-.42.78,1.55,1.55,0,0,1-.88.27,2,2,0,0,1-1.19-.46A.36.36,0,0,1,198.38,281.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.62,281.31a.34.34,0,0,1,.5-.05,1.25,1.25,0,0,0,.74.29.89.89,0,0,0,.46-.13c.09-.08.12-.14.12-.2a.11.11,0,0,0,0-.06.24.24,0,0,0-.09-.08,1.37,1.37,0,0,0-.54-.19h0a2.71,2.71,0,0,1-.59-.18,1.07,1.07,0,0,1-.46-.39.76.76,0,0,1-.12-.42,1,1,0,0,1,.4-.74,1.45,1.45,0,0,1,.83-.25,1.68,1.68,0,0,1,1,.37.38.38,0,0,1,.11.5.35.35,0,0,1-.5.09,1.12,1.12,0,0,0-.61-.24.69.69,0,0,0-.41.12.21.21,0,0,0-.1.15.07.07,0,0,0,0,.05l.07.07a1.38,1.38,0,0,0,.49.16h0a2.49,2.49,0,0,1,.62.19,1.08,1.08,0,0,1,.48.4.86.86,0,0,1,.12.44,1,1,0,0,1-.42.78,1.5,1.5,0,0,1-.87.27,2,2,0,0,1-1.2-.46A.37.37,0,0,1,201.62,281.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,279.45l-1.11,2.61s0,0,0,.05h0l0,0h0l0,0h0s0,0-.06,0h-.27s0,0-.06,0h0l0,0h0l0,0h0l0-.05-.49-1.17-.47,1.17,0,.05h0l0,0h0l0,0s0,0-.06,0h-.28a.1.1,0,0,1-.07,0h0l0,0h0s0,0,0,0h0l0-.05-1.1-2.61A.34.34,0,0,1,205,279a.32.32,0,0,1,.44.2l.8,1.81.47-1.13a.35.35,0,0,1,.32-.21.34.34,0,0,1,.33.21l.48,1.13.79-1.81a.33.33,0,0,1,.45-.2A.35.35,0,0,1,209.3,279.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,281.78a1.65,1.65,0,0,1-.46-1.18,1.74,1.74,0,0,1,.46-1.18,1.59,1.59,0,0,1,1.16-.51,1.51,1.51,0,0,1,1.12.51,1.71,1.71,0,0,1,.47,1.18,1.62,1.62,0,0,1-.47,1.18,1.48,1.48,0,0,1-1.12.51A1.55,1.55,0,0,1,210.9,281.78Zm.27-1.18a1.11,1.11,0,0,0,.24.71.92.92,0,0,0,.65.25.86.86,0,0,0,.61-.25,1,1,0,0,0,.27-.71,1,1,0,0,0-.27-.7.91.91,0,0,0-.61-.25,1,1,0,0,0-.65.25A1.08,1.08,0,0,0,211.17,280.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.72,279.27a.36.36,0,0,1-.35.36.71.71,0,0,0-.41.12,1.23,1.23,0,0,0-.31.33,1.81,1.81,0,0,0-.27.56v1.28a.37.37,0,0,1-.73,0v-2.65a.37.37,0,0,1,.73,0v.05a.93.93,0,0,1,.14-.14,1.43,1.43,0,0,1,.85-.26A.35.35,0,0,1,216.72,279.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,281.91a.36.36,0,0,1-.36.36.36.36,0,0,1-.35-.29,1.62,1.62,0,0,1-.92.29,1.68,1.68,0,0,1,0-3.36,1.56,1.56,0,0,1,.9.29v-1.27a.37.37,0,0,1,.73,0v2.66h0Zm-1.63-2.26a.89.89,0,0,0-.63.27,1,1,0,0,0-.27.68.92.92,0,0,0,.27.66.86.86,0,0,0,.63.28.83.83,0,0,0,.63-.28.92.92,0,0,0,.27-.66,1,1,0,0,0-.27-.68A.85.85,0,0,0,218.84,279.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.42,
    y: 287.39,
    width: 121.16,
    height: 14.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.74,317.9a.13.13,0,0,1,.13-.13.13.13,0,0,1,.14.13v3.65a.14.14,0,0,1-.14.14.13.13,0,0,1-.13-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.32,319.08v2.47a.13.13,0,1,1-.26,0v-.4a1.3,1.3,0,0,1-1,.54,1.37,1.37,0,0,1,0-2.74,1.29,1.29,0,0,1,1,.53v-.4a.13.13,0,0,1,.26,0Zm-.26,1.24a1,1,0,1,0-1,1.1A1.07,1.07,0,0,0,202.06,320.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.08,321.47a1.3,1.3,0,0,1-1.3,1.29,1.4,1.4,0,0,1-.57-.13.14.14,0,0,1-.05-.18.12.12,0,0,1,.18-.06,1,1,0,0,0,.44.1,1,1,0,0,0,1-1v-.34a1.23,1.23,0,0,1-1,.54,1.36,1.36,0,0,1,0-2.72,1.27,1.27,0,0,1,1,.53v-.4A.13.13,0,0,1,206,319a.13.13,0,0,1,.13.13Zm-.27-1.16a1,1,0,1,0-1,1.1A1.06,1.06,0,0,0,205.81,320.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.37,319.09a.14.14,0,0,1,.14-.14.13.13,0,0,1,.13.14v.6l0-.07a1.34,1.34,0,0,1,1.1-.67.13.13,0,0,1,.13.14.13.13,0,0,1-.13.13,1,1,0,0,0-.8.45,2.42,2.42,0,0,0-.33.64.08.08,0,0,0,0,0v1.2a.13.13,0,0,1-.13.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,320.32a1.33,1.33,0,0,1,2.66-.1h0v0a.13.13,0,0,1-.14.12h-2.25a1.08,1.08,0,0,0,1.07,1.05,1,1,0,0,0,.88-.5.13.13,0,0,1,.18,0,.15.15,0,0,1,.05.19,1.33,1.33,0,0,1-1.11.62A1.36,1.36,0,0,1,209.35,320.32Zm.29-.22h2.08a1.05,1.05,0,0,0-2.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76,320.32a1.33,1.33,0,0,1,2.65-.1h0v0a.12.12,0,0,1-.13.12H213a1.08,1.08,0,0,0,1.06,1.05,1,1,0,0,0,.89-.5.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.19,1.31,1.31,0,0,1-1.11.62A1.35,1.35,0,0,1,212.76,320.32Zm.29-.22h2.07a1,1,0,0,0-2.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,319.08a.14.14,0,0,1-.13.13h-.36v2a.22.22,0,0,0,.2.21.14.14,0,1,1,0,.27.47.47,0,0,1-.48-.48v-2h-.34c-.13,0-.13-.06-.13-.13s0-.13.13-.13h.34v-1a.14.14,0,1,1,.28,0v1h.36A.14.14,0,0,1,219,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,319a1.37,1.37,0,0,1,0,2.74,1.37,1.37,0,0,1,0-2.74Zm0,2.47a1.11,1.11,0,1,0-1-1.1A1.07,1.07,0,0,0,221.37,321.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,319.08v2.47a.13.13,0,0,1-.13.14.14.14,0,0,1-.14-.14v-.4a1.28,1.28,0,0,1-1,.54,1.37,1.37,0,0,1,0-2.74,1.27,1.27,0,0,1,1,.53v-.4a.13.13,0,0,1,.14-.13A.13.13,0,0,1,227.67,319.08Zm-.27,1.24a1,1,0,1,0-1,1.1A1.07,1.07,0,0,0,227.4,320.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,317.9a.13.13,0,0,1,.14-.13.14.14,0,0,1,.14.13v3.65a.14.14,0,0,1-.14.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34,317.9a.14.14,0,0,1,.28,0v3.65a.14.14,0,0,1-.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.19,321.12a.13.13,0,0,1,.19,0,1.46,1.46,0,0,0,.84.32.85.85,0,0,0,.52-.17.39.39,0,0,0,0-.67,1.34,1.34,0,0,0-.59-.2h0a1.56,1.56,0,0,1-.62-.21.57.57,0,0,1-.29-.49.69.69,0,0,1,.29-.54,1.18,1.18,0,0,1,.67-.18,1.48,1.48,0,0,1,.82.29.14.14,0,0,1,0,.19.13.13,0,0,1-.18,0,1.27,1.27,0,0,0-.68-.27.87.87,0,0,0-.52.15.43.43,0,0,0-.17.32.32.32,0,0,0,.16.27,1.25,1.25,0,0,0,.56.19h0a1.84,1.84,0,0,1,.66.23.67.67,0,0,1,.31.56.7.7,0,0,1-.31.55,1.13,1.13,0,0,1-.68.22,1.7,1.7,0,0,1-1-.39A.13.13,0,0,1,233.19,321.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.17,319.08a.14.14,0,0,1-.13.13h-.36v2a.22.22,0,0,0,.2.21.14.14,0,1,1,0,.27.47.47,0,0,1-.48-.48v-2h-.34c-.13,0-.13-.06-.13-.13s0-.13.13-.13h.34v-1a.14.14,0,1,1,.28,0v1H237A.14.14,0,0,1,237.17,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.58,319.08v2.47a.13.13,0,0,1-.13.14.14.14,0,0,1-.14-.14v-.4a1.28,1.28,0,0,1-1,.54,1.37,1.37,0,0,1,0-2.74,1.27,1.27,0,0,1,1,.53v-.4a.13.13,0,0,1,.14-.13A.13.13,0,0,1,240.58,319.08Zm-.27,1.24a1,1,0,1,0-1,1.1A1.07,1.07,0,0,0,240.31,320.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,319.08a.14.14,0,0,1-.13.13h-.36v2a.22.22,0,0,0,.21.21.14.14,0,1,1,0,.27.46.46,0,0,1-.48-.48v-2h-.35c-.13,0-.13-.06-.13-.13s0-.13.13-.13h.35v-1a.14.14,0,0,1,.13-.14.15.15,0,0,1,.14.14v1h.36A.14.14,0,0,1,242.7,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.56,320.32a1.33,1.33,0,0,1,2.66-.1h0v0a.13.13,0,0,1-.14.12h-2.25a1.08,1.08,0,0,0,1.07,1.05,1,1,0,0,0,.88-.5.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.19,1.3,1.3,0,0,1-1.1.62A1.36,1.36,0,0,1,243.56,320.32Zm.29-.22h2.08a1.05,1.05,0,0,0-2.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.09,320.07a.85.85,0,1,0-1.7,0v1.51h0a.12.12,0,0,1-.07.07l-.07,0h-.09v0h0s0,0,0,0v0h0v-1.49a.85.85,0,1,0-1.69,0v1.49a.13.13,0,0,1-.06.11h-.09a.17.17,0,0,1-.12-.1v-2.51a.14.14,0,0,1,.13-.13.13.13,0,0,1,.14.13v.26a1.08,1.08,0,0,1,.84-.39,1.12,1.12,0,0,1,1,.58,1.16,1.16,0,0,1,1-.58,1.11,1.11,0,0,1,1.11,1.12v1.49a.13.13,0,0,1-.13.13.13.13,0,0,1-.13-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29,320.32a1.33,1.33,0,0,1,2.65-.1h0v0a.12.12,0,0,1-.13.12h-2.25a1.08,1.08,0,0,0,1.06,1.05,1,1,0,0,0,.89-.5.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.19,1.31,1.31,0,0,1-1.11.62A1.35,1.35,0,0,1,252.29,320.32Zm.29-.22h2.07a1,1,0,0,0-2.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.85,320.07a.84.84,0,0,0-.84-.85.86.86,0,0,0-.85.85v1.51l0,.06a.14.14,0,0,1-.1.05h0a.16.16,0,0,1-.09-.07v0a0,0,0,0,0,0,0v-2.5A.14.14,0,0,1,256,319a.13.13,0,0,1,.13.14v.26a1.11,1.11,0,0,1,2,.72v1.48a.13.13,0,0,1-.13.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,319.08a.14.14,0,0,1-.14.13h-.35v2a.22.22,0,0,0,.2.21.14.14,0,1,1,0,.27.47.47,0,0,1-.48-.48v-2h-.34c-.13,0-.13-.06-.13-.13s0-.13.13-.13h.34v-1a.14.14,0,1,1,.28,0v1h.35A.14.14,0,0,1,260.28,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.37,321.12a.13.13,0,0,1,.19,0,1.46,1.46,0,0,0,.84.32.83.83,0,0,0,.52-.17.43.43,0,0,0,.21-.33.46.46,0,0,0-.2-.34,1.29,1.29,0,0,0-.58-.2h0a1.46,1.46,0,0,1-.62-.21.56.56,0,0,1-.3-.49.67.67,0,0,1,.3-.54,1.18,1.18,0,0,1,.67-.18,1.54,1.54,0,0,1,.82.29.14.14,0,0,1,0,.19.13.13,0,0,1-.18,0,1.21,1.21,0,0,0-.67-.27.83.83,0,0,0-.52.15.41.41,0,0,0-.18.32.32.32,0,0,0,.16.27,1.3,1.3,0,0,0,.56.19h0a1.89,1.89,0,0,1,.67.23.67.67,0,0,1,.31.56.68.68,0,0,1-.32.55,1.11,1.11,0,0,1-.68.22,1.67,1.67,0,0,1-1-.39A.12.12,0,0,1,261.37,321.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,318.18a.13.13,0,0,1,.13-.13.13.13,0,0,1,.14.13v.13a.14.14,0,1,1-.27,0Zm0,.9a.13.13,0,0,1,.13-.13.13.13,0,0,1,.14.13v2.47a.14.14,0,0,1-.14.14.13.13,0,0,1-.13-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.52,320.07a.84.84,0,0,0-.84-.85.86.86,0,0,0-.85.85v1.51l0,.06a.14.14,0,0,1-.1.05h0a.16.16,0,0,1-.09-.07v0a0,0,0,0,0,0,0v-2.5a.14.14,0,0,1,.14-.14.13.13,0,0,1,.13.14v.26a1.1,1.1,0,0,1,.85-.4,1.12,1.12,0,0,1,1.11,1.12v1.48a.13.13,0,0,1-.13.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.63,319.08a.14.14,0,0,1-.14.13h-.35v2a.22.22,0,0,0,.2.21.14.14,0,1,1,0,.27.47.47,0,0,1-.48-.48v-2h-.34c-.14,0-.14-.06-.14-.13s0-.13.14-.13h.34v-1a.15.15,0,0,1,.13-.14.15.15,0,0,1,.15.14v1h.35A.14.14,0,0,1,273.63,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.49,320.32a1.33,1.33,0,0,1,2.65-.1h0v0a.12.12,0,0,1-.13.12h-2.25a1.06,1.06,0,0,0,1.06,1.05,1,1,0,0,0,.88-.5.13.13,0,0,1,.18,0,.13.13,0,0,1,.05.19,1.33,1.33,0,0,1-1.11.62A1.35,1.35,0,0,1,274.49,320.32Zm.28-.22h2.08a1.05,1.05,0,0,0-2.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,319.09a.14.14,0,0,1,.14-.14.13.13,0,0,1,.13.14v.6l0-.07a1.34,1.34,0,0,1,1.1-.67.13.13,0,0,1,.13.14.13.13,0,0,1-.13.13,1,1,0,0,0-.8.45,2.42,2.42,0,0,0-.33.64.08.08,0,0,0,0,0v1.2a.13.13,0,0,1-.13.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.35,320.07a.85.85,0,1,0-1.69,0v1.51h0a.12.12,0,0,1-.07.07l-.06,0h-.09l0,0h0s0,0,0,0v0h0v-1.49a.85.85,0,1,0-1.69,0v1.49a.13.13,0,0,1-.06.11h-.09a.16.16,0,0,1-.11-.1v-2.51a.13.13,0,0,1,.26,0v.26a1.11,1.11,0,0,1,.85-.39,1.12,1.12,0,0,0,2,0,1.12,1.12,0,0,1,1.12,1.12v1.49a.13.13,0,0,1-.14.13.13.13,0,0,1-.13-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.56,321.12a.13.13,0,0,1,.19,0,1.46,1.46,0,0,0,.84.32.83.83,0,0,0,.52-.17.43.43,0,0,0,.21-.33.46.46,0,0,0-.2-.34,1.29,1.29,0,0,0-.58-.2h0a1.46,1.46,0,0,1-.62-.21.56.56,0,0,1-.3-.49.67.67,0,0,1,.3-.54,1.18,1.18,0,0,1,.67-.18,1.48,1.48,0,0,1,.81.29.13.13,0,0,1,0,.19.13.13,0,0,1-.18,0,1.21,1.21,0,0,0-.67-.27.83.83,0,0,0-.52.15.41.41,0,0,0-.18.32.32.32,0,0,0,.16.27,1.3,1.3,0,0,0,.56.19h0a1.89,1.89,0,0,1,.67.23.66.66,0,0,1,.3.56.67.67,0,0,1-.31.55,1.11,1.11,0,0,1-.68.22,1.67,1.67,0,0,1-1-.39A.12.12,0,0,1,285.56,321.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.35,319a1.37,1.37,0,1,1-1.3,1.37A1.34,1.34,0,0,1,291.35,319Zm0,2.47a1.11,1.11,0,1,0-1-1.1A1.07,1.07,0,0,0,291.35,321.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.69,317.92a.13.13,0,0,1-.14.13c-.19,0-.29,0-.34.11a.66.66,0,0,0-.11.45v.29h.38a.14.14,0,0,1,.14.14.13.13,0,0,1-.14.13h-.38v2.39a.15.15,0,0,1-.14.14.14.14,0,0,1-.14-.14v-2.39h-.36a.13.13,0,0,1-.14-.13.14.14,0,0,1,.14-.14h.36v-.29A1,1,0,0,1,294,318a.74.74,0,0,1,.55-.19A.14.14,0,0,1,294.69,317.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,321.12a.13.13,0,0,1,.19,0,1.49,1.49,0,0,0,.84.32.81.81,0,0,0,.52-.17.38.38,0,0,0,0-.67,1.25,1.25,0,0,0-.58-.2h0a1.51,1.51,0,0,1-.62-.21.58.58,0,0,1-.3-.49.7.7,0,0,1,.3-.54A1.18,1.18,0,0,1,298,319a1.51,1.51,0,0,1,.82.29.14.14,0,0,1,0,.19.14.14,0,0,1-.19,0,1.21,1.21,0,0,0-.67-.27.87.87,0,0,0-.52.15.43.43,0,0,0-.17.32.33.33,0,0,0,.15.27,1.35,1.35,0,0,0,.56.19h0a1.83,1.83,0,0,1,.67.23.67.67,0,0,1,.31.56.7.7,0,0,1-.31.55,1.14,1.14,0,0,1-.69.22,1.67,1.67,0,0,1-1-.39A.13.13,0,0,1,297,321.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.74,320.32a1.33,1.33,0,0,1,2.65-.1h0v0a.12.12,0,0,1-.13.12H300a1.08,1.08,0,0,0,1.06,1.05,1,1,0,0,0,.89-.5.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.19,1.31,1.31,0,0,1-1.11.62A1.35,1.35,0,0,1,299.74,320.32Zm.28-.22h2.08a1.06,1.06,0,0,0-1-.89A1.09,1.09,0,0,0,300,320.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.22,319.09a.15.15,0,0,1,.15-.14.13.13,0,0,1,.12.14v.6a.43.43,0,0,0,0-.07,1.34,1.34,0,0,1,1.1-.67.13.13,0,0,1,.13.14.13.13,0,0,1-.13.13,1,1,0,0,0-.8.45,2.42,2.42,0,0,0-.33.64.08.08,0,0,0,0,0v1.2a.13.13,0,0,1-.12.14.15.15,0,0,1-.15-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,321.67l0-.06-1-2.46a.13.13,0,0,1,.06-.17.14.14,0,0,1,.18.07l.91,2.16.91-2.16a.12.12,0,0,1,.17-.07.13.13,0,0,1,.07.17l-1,2.43a.16.16,0,0,1,0,.07.11.11,0,0,1-.09,0h-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.94,318.18a.13.13,0,0,1,.14-.13.14.14,0,0,1,.14.13v.13a.15.15,0,0,1-.14.15.15.15,0,0,1-.14-.15Zm0,.9a.13.13,0,0,1,.14-.13.13.13,0,0,1,.14.13v2.47a.14.14,0,0,1-.14.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31,320.31a1.38,1.38,0,0,1,1.41-1.36,1.42,1.42,0,0,1,.88.3.13.13,0,0,1,0,.18.14.14,0,0,1-.18,0,1.12,1.12,0,1,0-.71,2,1.17,1.17,0,0,0,.71-.24.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.2,1.42,1.42,0,0,1-.87.29A1.39,1.39,0,0,1,310.31,320.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,320.32a1.33,1.33,0,0,1,2.66-.1h0v0a.13.13,0,0,1-.14.12h-2.25a1.08,1.08,0,0,0,1.06,1.05,1,1,0,0,0,.89-.5.13.13,0,0,1,.18,0,.14.14,0,0,1,0,.19,1.31,1.31,0,0,1-1.11.62A1.36,1.36,0,0,1,313.42,320.32Zm.29-.22h2.08a1.05,1.05,0,0,0-2.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,323.48H183v-7.92h7.92Zm-6.92-1h5.92v-5.92H184Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,224.34a1.46,1.46,0,1,1-1.46-1.46A1.45,1.45,0,0,1,304,224.34Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.06,228.34H300a2.53,2.53,0,0,1,5.05,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,258.65l-.86-.69h6.75l-.86.69c-.29.23-.58.46-.86.7l-.95.8h0l-.71.6-.71-.6h0l-.95-.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,258v4.28h-6.75V258l.82.77.84.75.87.77,0,0,0,0-.05,0a6.26,6.26,0,0,0-.55.34c-.23.14-.45.29-.68.45l-.65.47c-.22.17-.43.33-.64.51.24-.13.47-.27.7-.42s.45-.29.67-.45.45-.31.66-.47.35-.27.52-.42l0,0,.74.64,0,0,0,0,.74-.64,0,0c.17.15.34.28.51.42l.66.47c.22.16.45.31.67.45s.46.29.7.42c-.2-.18-.42-.34-.63-.51l-.66-.47c-.22-.16-.44-.31-.67-.45a6.42,6.42,0,0,0-.56-.34l-.05,0,0,0,0,0,.88-.77.83-.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.53,292.93a4.93,4.93,0,0,0-3.37,1.67,4.26,4.26,0,0,0,6.75,0A4.94,4.94,0,0,0,302.53,292.93Zm0,2.85a1.19,1.19,0,1,1,1.19-1.19A1.18,1.18,0,0,1,302.53,295.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29,294.59a.76.76,0,1,1-1.51,0,.76.76,0,0,1,1.51,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.06,
    y: 340.49,
    width: 57.89,
    height: 17.46,
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,350.62a.46.46,0,0,1,.65-.06,2.93,2.93,0,0,0,1.71.69,1.91,1.91,0,0,0,1.12-.33.81.81,0,0,0,.39-.65.54.54,0,0,0-.08-.28,1,1,0,0,0-.27-.27,3.63,3.63,0,0,0-1.23-.42h0a4.84,4.84,0,0,1-1.15-.35,2,2,0,0,1-.84-.7,1.44,1.44,0,0,1-.2-.74,1.64,1.64,0,0,1,.71-1.3,2.62,2.62,0,0,1,1.55-.48,3.51,3.51,0,0,1,2,.72.46.46,0,0,1,.12.63.45.45,0,0,1-.63.14,2.58,2.58,0,0,0-1.45-.57,1.7,1.7,0,0,0-1,.3.72.72,0,0,0-.34.56.46.46,0,0,0,.06.25.91.91,0,0,0,.24.24,3.21,3.21,0,0,0,1.12.39h0a5.31,5.31,0,0,1,1.24.38,2,2,0,0,1,.89.74,1.43,1.43,0,0,1,.22.76,1.72,1.72,0,0,1-.77,1.39,2.82,2.82,0,0,1-1.66.51,3.87,3.87,0,0,1-2.29-.89A.47.47,0,0,1,231.7,350.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,346.4a.48.48,0,0,1,.49-.49.5.5,0,0,1,.5.49v5.29a.49.49,0,0,1-.5.49.48.48,0,0,1-.49-.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.32,349a3.31,3.31,0,0,1,5.34-2.53.51.51,0,1,1-.62.81,2.32,2.32,0,0,0-1.42-.49,2.19,2.19,0,0,0-1.61.66,2.13,2.13,0,0,0,0,3.1,2.22,2.22,0,0,0,1.61.65,2.44,2.44,0,0,0,1.23-.34v-1.23h-1.28a.51.51,0,0,1-.51-.51.5.5,0,0,1,.51-.5h1.78a.5.5,0,0,1,.52.5v2a.66.66,0,0,1,0,.15.09.09,0,0,0,0,.05h0a.44.44,0,0,1-.18.21,3.28,3.28,0,0,1-2,.7A3.25,3.25,0,0,1,240.32,349Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.87,351.69a.5.5,0,0,1-.49.49.48.48,0,0,1-.49-.49v-5.21h0a.48.48,0,0,1,.2-.42.5.5,0,0,1,.68.11l2.89,4v-3.69a.49.49,0,0,1,.48-.48.5.5,0,0,1,.5.48v5.21a.5.5,0,0,1-.5.49.47.47,0,0,1-.36-.18l-.05-.05-2.86-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.06,352.18a2.58,2.58,0,0,1-2.58-2.59V346.4a.48.48,0,0,1,.49-.49.5.5,0,0,1,.5.49v3.19a1.6,1.6,0,1,0,3.19,0V346.4a.49.49,0,0,1,.5-.49.48.48,0,0,1,.49.49v3.19A2.58,2.58,0,0,1,260.06,352.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.85,349.74h-1.1v1.95a.5.5,0,0,1-1,0V346.4a.5.5,0,0,1,.49-.49h1.61a1.92,1.92,0,1,1,0,3.83Zm-1.1-1h1.1a.92.92,0,1,0,0-1.84h-1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.78,
    cy: 144.3,
    r: 11.52,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 186.98,
    r: 8.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.42,191.58a30.71,30.71,0,0,1-9,3.76,31.17,31.17,0,1,1,9-3.76Z",
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.51,161.49A9.49,9.49,0,1,1,250,152,9.48,9.48,0,0,1,259.51,161.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.42,187.67v3.91a30.71,30.71,0,0,1-9,3.76,31,31,0,0,1-23.8-3.77v-3.9a16.4,16.4,0,1,1,32.79,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.14,217.82a21.6,21.6,0,0,1-.37-4.23,20.86,20.86,0,0,1,.37-4.23,20.87,20.87,0,0,1,.38,4.23A21.61,21.61,0,0,1,287.14,217.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.13,220.49a21.9,21.9,0,0,1-3.25-2.72,21.44,21.44,0,0,1-2.73-3.26,24,24,0,0,1,6,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,226.63a21.5,21.5,0,0,1-4.22.37,20.86,20.86,0,0,1-4.23-.37,24.31,24.31,0,0,1,8.45,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,232.64a24.5,24.5,0,0,1-6,6,20.82,20.82,0,0,1,2.72-3.26A22,22,0,0,1,281.45,232.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.58,235a23.68,23.68,0,0,1,0,8.45,24.31,24.31,0,0,1,0-8.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,232.33a23.78,23.78,0,0,1,6,6,20.74,20.74,0,0,1-3.25-2.72A21.86,21.86,0,0,1,293.59,232.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,226.19a23.73,23.73,0,0,1,8.46,0,24.36,24.36,0,0,1-8.46,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.28,220.18a22,22,0,0,1,2.72-3.26,21.38,21.38,0,0,1,3.26-2.72,24.5,24.5,0,0,1-6,6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.38,131.45s7,48.69,6.53,53.32-6.18,49.51-6.18,49.51-12.82-2.76-16.52-5c-2.66-1.59-12.08-9.71-12.08-9.71s16-31.3,17.32-37.65,2.19-37.14,3.72-43.34a12.6,12.6,0,0,1,7.36-8.32",
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.32,199a10.57,10.57,0,0,0,3.94,4.29c.87.59,2.55,1.85,3.08.22a2.93,2.93,0,0,0-.22-1.89,10.47,10.47,0,0,0-1.82-3.09c-.94-1.15-2.5-2.66-4.14-2.38S322.83,197.86,323.32,199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.57,206.82a10,10,0,0,0,2.36,5.79c.69.72,1.49.95,2.11.45s.95-1.58,1-2.44a10.78,10.78,0,0,0-1.1-6c-.59-1.15-1.63-2.75-3.16-2.4C332.86,202.72,333.38,205.41,333.57,206.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,206c-.87.68,0,3.3.81,4.54,1,1.58,2.73,3.38,4.16,2.7.72-.35.82-2.3-.76-4.75C328.48,206.24,326.47,205.46,325.75,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37,220.44c.34.67,1.08,1.85,1.95,1.89s1-.84,1-1.48a9.75,9.75,0,0,0-.55-2.93c-.41-1.28-1.17-2.39-2.4-2.46C318.94,215.33,320.93,219.58,321.37,220.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.3,358.4S420.1,397,420.11,397c3.5,7.77,6.43,14.65,7.62,18.35a.14.14,0,0,1,0,.06,6,6,0,0,1,.51,2.66s0,.05,0,.07c-1.61,2.61-62.92,32.41-65.41,32.73s-3.59-6.75-2.13-9.81,19.84-25,19.84-25l-21.41-38.7Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.81,450.62c2.48-.32,62.82-29.89,64.42-32.5l0-.07a6,6,0,0,0-.51-2.66.06.06,0,0,0,0-.05c-1.19-3.7-4.12-10.59-7.61-18.36,0,0-3.68-6.74-5.14-9.08l-39,20.16,4.54,8s-17.39,21.68-18.85,24.74S361.31,451,363.81,450.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.68,449.79c2.51-.38,63.6-31.85,65.16-34.53.61-1-3.46-10.17-8.69-21.11,0-.11-.11-.23-.17-.34l-39.63,19.86.36.66s-18,22.51-19.41,25.63S360.18,450.18,362.68,449.79Z",
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.16,447.07c10.16-5.56,51.7-27,62.17-31.74.08,0,.11,0,0,.06-10,5.73-51.66,26.85-62.12,31.84C362,447.34,361.94,447.18,362.16,447.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.46,416.16c3.66-2.84,8.94-4.78,13.52-3.48.18.05.1.3-.05.32a64.22,64.22,0,0,0-13.19,3.66A.29.29,0,0,1,376.46,416.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.44,419.43c3.66-2.85,8.94-4.78,13.52-3.48.18.05.11.3,0,.32a64.57,64.57,0,0,0-13.19,3.66A.29.29,0,0,1,374.44,419.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.42,422.7c3.67-2.85,8.94-4.78,13.53-3.48.17,0,.1.3-.05.32a64.49,64.49,0,0,0-13.2,3.66A.29.29,0,0,1,372.42,422.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,405.85c3.29-4.5,10.28.6,7,5.11S409.13,410.35,412.42,405.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,417.71l-4.39,27.43a108.44,108.44,0,0,1-9.94,4.65c-2.5.39-3.78-6.72-2.39-9.83C361.37,437.6,372,424.11,377,417.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.62,448.08c-.87,1,1.26,4.54,2.2,4.42s67.39-34.72,68.39-35.55-1.5-4.69-2.93-4.22S360.62,448.08,360.62,448.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.07,384.3l-43.94,23.46s-55.46-79-56.56-99.8c-1.54-28.68,22.95-119.73,22.95-119.73l39.06-.26S360.7,281.6,362,297.57C362.67,305.93,415.07,384.3,415.07,384.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.3,398.68c2.26-1.63,23.09-13.7,38.95-21.41.1,0,.17.1.08.16-4.81,3.18-35.9,20.21-38.91,21.42C367.32,398.89,367.2,398.75,367.3,398.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.57,277.57c1.81-13.7,3.81-27.39,6.09-41s4.69-27.38,7.56-41q.52-2.49,1.07-5a.2.2,0,0,1,.4.08c-2.4,13.48-4.88,26.95-7.09,40.46s-4.28,27-6.14,40.62c-.46,3.36-.9,6.72-1.34,10.08a89.61,89.61,0,0,0-1,10.46,26.69,26.69,0,0,0,1.67,9.81,56.77,56.77,0,0,0,4.5,8.82c7.07,11.95,38.71,64.19,39.53,65.71.06.1-.08.2-.14.1-7.6-11.78-31.16-49.42-38.32-61.57-3.24-5.48-6.94-11-8-17.42C354.28,291.11,355.69,284.16,356.57,277.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.82,384.3s.44,44.56.44,44.59c-.23,8.52-.59,16-1.14,19.84a.13.13,0,0,1,0,.06,5.94,5.94,0,0,1-.7,2.62l-.05,0c-2.58,1.65-70.75,1.75-73.13,1s-.3-7.64,2.35-9.75,28.73-13.83,28.73-13.83l0-44.53Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.17,419.74s.09,9.12.09,9.15c-.23,8.52-.59,16-1.14,19.84a.13.13,0,0,1,0,.06,11,11,0,0,1-.7,2.62l-.05,0c-2.58,1.65-70.75,1.75-73.13,1s-.3-7.64,2.35-9.75,28.73-13.83,28.73-13.83v-9.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.2,452.33c2.41.76,71.12-.44,73.7-2.15,1-.64,1.4-10.66,1.55-22.78V427l-44.34.28,0,.76s-26.09,12.22-28.74,14.4S290.78,451.57,293.2,452.33Z",
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.93,449.65c11.57-.49,58.31-1.37,69.79-1,.1,0,.1.07,0,.08-11.46.73-58.2,1.23-69.79,1.08C293.68,449.84,293.68,449.66,293.93,449.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.42,428.26c4.54-.94,10.13-.33,13.67,2.85.14.13,0,.32-.19.27a64.66,64.66,0,0,0-13.45-2.55A.29.29,0,0,1,320.42,428.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,430.3c4.54-.94,10.13-.33,13.66,2.85.14.13,0,.32-.18.27a64.76,64.76,0,0,0-13.46-2.55A.29.29,0,0,1,317.17,430.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,432.34c4.54-.93,10.13-.33,13.67,2.85.14.13,0,.32-.19.28a64,64,0,0,0-13.45-2.56A.29.29,0,0,1,313.91,432.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.1,449.88c-1.22.5-.88,4.62,0,4.94s75.8-1.33,77.07-1.64.72-4.87-.76-5.08S292.1,449.88,292.1,449.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.24,434.91c4.94-2.57,8.95,5.09,4,7.68S352.29,437.5,357.24,434.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,188.14s0,0,0,0c.26.81,14.29,39.27,15.62,39.89,1.49.69-31,55.29-32.94,80.65-1.23,16.23,1.19,108,1.19,108h47.52s-2.29-82.54-3.37-108.7c-.42-10.14,32.63-60.63,33-92.08.13-9.91-7-28-7-28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.78,307.36c0-.42.33-.56.36-.13,1.07,14.16,1.32,28.23,2,42.41s.29,17.55.92,31.68c.36,8,0,16,.2,24a.1.1,0,0,1-.19,0C367.59,391.26,365.79,315.37,365.78,307.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.71,309.28a71.45,71.45,0,0,1,1-10.42,52.2,52.2,0,0,1,2.94-9.78c2.62-6.62,5.73-13.08,8.7-19.55s6.07-13.09,9.24-19.57q2.67-5.46,5.37-10.91c1.83-3.67,3.8-7.28,5.71-10.91.07-.14.3,0,.23.11-3.05,6.54-6.05,13.1-9.1,19.64s-6,13.11-9,19.67-5.89,12.92-8.67,19.45a64.5,64.5,0,0,0-3.39,9.61A56.36,56.36,0,0,0,322.28,307c-.46,8.11-.68,16.26-1.48,24.35,0,.1-.18.09-.18,0C320.38,324,320.49,316.61,320.71,309.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.34,407.37c2.76-.36,23.82-1.09,41.43-.34a.09.09,0,0,1,0,.18c-5.74.51-38.18.73-41.41.36C325.25,407.56,325.21,407.38,325.34,407.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.08,225.93a91,91,0,0,1,14.86,5.15.16.16,0,0,1-.11.31c-5-1.56-10.06-3-14.95-4.86A.32.32,0,0,1,347.08,225.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.28,193.35c0-.16.29-.23.3,0,.55,5.68,1.42,10.63,2.44,15.88.48,2.44,3.85,15.84,8,14.41.7-.24,1-1,1-2.07a17,17,0,0,0-1-4.11c-.76-2.8-1.44-5.62-2-8.47a79.18,79.18,0,0,1-1.47-16.11.14.14,0,0,1,.28,0,148.51,148.51,0,0,0,3.57,22.08c.9,3.48,3.23,8.62-.42,9.55s-7.06-7.73-7.77-10.13A82,82,0,0,1,342.28,193.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,224a22.3,22.3,0,0,1,1.25,2.72,6.32,6.32,0,0,1,.63,2.27c0,.15-.19.19-.29.1a8.49,8.49,0,0,1-1.22-2.16c-.41-.84-.84-1.67-1.23-2.52A.48.48,0,0,1,353,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.91,321.32c-.24-6.75-1-13.84,1.22-20.36a67.71,67.71,0,0,1,4.34-9.25q2.46-4.75,4.85-9.58c6.35-12.82,12.33-25.85,17.67-39.13,2.58-6.39,4.88-12.95,5.8-19.81a60.9,60.9,0,0,0-1.33-21.56c-.4-1.76-.83-3.51-1.31-5.25,0-.12.16-.2.2-.07a71.08,71.08,0,0,1,3.71,20.62,58.45,58.45,0,0,1-3.58,19.7c-2.28,6.64-5.13,13.08-7.94,19.51q-4.35,9.92-9,19.7c-3.11,6.48-6.43,12.85-9.71,19.25a35.18,35.18,0,0,0-3.65,9.71,50.36,50.36,0,0,0-.39,10.63c.56,14.95,1.85,64.69,2,79.6,0,1.89.05,3.78.07,5.68,0,.16-.25.19-.26,0C362.66,385.85,361.45,336.22,360.91,321.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.57,197.82c0-.1.17-.08.18,0,.56,4.12.88,8.38,2.87,12.11,1.82,3.43,5,5.64,8.46,7.18a64.22,64.22,0,0,0,6.17,2.28c.15,0,.12.28-.05.24-3.93-.81-7.92-1.73-11.34-3.94-3.66-2.36-5.54-6.14-6.14-10.37A35.58,35.58,0,0,1,371.57,197.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,191.15c-.09.19-62.6,17.22-63.3,16.77-.07,0-2.65-1.44-3.21-6.27-.16-1.33,1.62-7,1.67-11.27.14-14.81-.44-42.31,3.59-57.08,1.08-4,9.63-8.52,14.32-5.63C368.7,140.66,394.62,190.9,394.5,191.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,126.51s2.32,31.53,3.16,35.19c.58,2.56,7.66,28.3,11.3,46.9,1.56,8,.83,20.51.83,20.51s21.77-7.07,28.44-11.61c3.86-2.63,12.47-14,12.47-14S386.85,172.93,379,161.45s-22.77-31.35-29.76-34.25C346.09,125.88,344.43,126.51,344.43,126.51Z",
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.4,179.57a3.49,3.49,0,0,0-1.86,2.76,11,11,0,0,0-.47,4.95c.13.9.53,2.23,1.7,2s1.82-2.23,2.13-3.25S386.13,178.41,383.4,179.57Zm-9.27,7.66c-1.28,1.06-1.14,3.24-.87,4.69a10.27,10.27,0,0,0,1.16,3.39,3,3,0,0,0,1.3,1.4c1.59.65,1.71-1.44,1.83-2.49a10.56,10.56,0,0,0-.71-5.78C376.32,187.35,375.31,186.25,374.13,187.23Zm4.49-12.18c-1-.12-1.53.63-1.81,1.62a9.12,9.12,0,0,0-.39,3.56c.08.73.24,2,1.05,2.3s1.46-.53,1.75-1.18C379.74,180.16,380.78,175.33,378.62,175.05ZM363.46,226c-.77,1.57-2.34.27-3.6-1.26h0c0-1.81.05-4,0-6.36l.34.28a11.15,11.15,0,0,1,2.89,4A3.52,3.52,0,0,1,363.46,226Zm7.19-.7-2.29.83a9.91,9.91,0,0,1-2.91-4.21c-.2-.68-.29-1.75.55-2s1.76.56,2.3,1.05a9.13,9.13,0,0,1,2,2.95A2.74,2.74,0,0,1,370.65,225.3Zm-5.89-54c.95-.05,1.84,1.3,2.26,2a9.78,9.78,0,0,1,1.24,3.8c.1.77.38,2.4-.34,3-.87.71-1.71-.1-2.33-1.21a8.8,8.8,0,0,1-1.85-5.55C363.75,172.64,363.83,171.36,364.76,171.3Zm7.12,28c-1.26.93-.72,2.76-.23,3.95a10.82,10.82,0,0,0,3.83,4.71c.71.48,1.78,1.06,2.54.78s1.12-.9,1-1.9a10,10,0,0,0-2.89-5.54C375.21,200.28,373.51,198.13,371.88,199.34Zm7.92.34c.84,2.81,2.39,4,3.12,3.67,1.44-.65,1.19-3.11.65-4.92-.42-1.42-1.85-3.78-2.94-3.56C379.74,195.05,379,197.09,379.8,199.68Zm-28.92-49a10.25,10.25,0,0,1-1.65,3.18,7.64,7.64,0,0,1-2.34,2.25c-.17-1.65-.35-3.56-.52-5.58h0a16.47,16.47,0,0,1,1.56-1.34c.84-.65,2.44-2,3.07-.4A3,3,0,0,1,350.88,150.68Zm4.67-.94c1.54.27,2.49-1.38,3-2.56a10.71,10.71,0,0,0,.76-6c-.14-.84-.46-2-1.18-2.38s-1.43-.18-2.08.57a10.05,10.05,0,0,0-2,5.92C353.93,146.68,353.55,149.4,355.55,149.74Zm-5.22-6c-1.34,2.35-3.31,3.24-4.06,2.72a.8.8,0,0,1-.29-.4s0,0,0,0c0-.39-.07-.79-.11-1.19v0a8.53,8.53,0,0,1,.95-3c.94-1.64,2.55-3.52,4-2.92C351.57,139.29,351.78,141.23,350.33,143.77Zm42.18,55.11c-.75,1-.4,2.27.32,3.41a9.29,9.29,0,0,0,1.87,2.33c.48.42,1.26.85,1.77.2s.12-2-.17-2.71C395.93,201.21,394,196.94,392.51,198.88Zm-19.6-33.58a2.44,2.44,0,0,0-.67,2.72,7.54,7.54,0,0,0,.82,2.3c.26.46.75,1,1.32.64s.63-1.53.59-2.15C374.93,168,374.58,164.2,372.91,165.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,142.69c3.53-.84,6.5-10.12,6.68-15.1,0-.34-1.32-2-3.39-5.27-1.26-2-2.6-4.25-3.68-6.39l-11.82,10a38.11,38.11,0,0,1,5.45,7.59,5.23,5.23,0,0,1,.35.92,1.66,1.66,0,0,0,.06.16C332,136.45,334.34,143.5,337.75,142.69Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91,136.59c-.24.13-.48.24-.71.35-.38-1-.66-1.82-.81-2.3a1.56,1.56,0,0,0-.05-.16,5.63,5.63,0,0,0-.35-.93,38.24,38.24,0,0,0-5.45-7.58l11.82-10c.23.45.46.9.71,1.36C339.44,122.21,341,132.29,332.91,136.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.66,101.44c3.88,4,8.39,19,6.57,23.84-2.64,6.95-10.46,11.48-17.25,7.51-6.57-3.85-12.1-23.55-9.74-28.26C314.72,97.58,325.93,95.51,331.66,101.44Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.56,117.11s.09,0,.11.06c.33,1,.88,2.1,1.9,2.1,0,0,.05,0,0,.06C323.43,119.58,322.72,118.12,322.56,117.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,115.75c1.55-.71,2.86,2.45,1.42,3.1S321.76,116.35,323.06,115.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,119.48s-.05.08,0,.12c.43,1,.77,2.14,0,2.83,0,0,0,.07,0,0C318,121.88,317.52,120.33,317,119.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.66,118.82c-1.62.53-.44,3.74,1.06,3.24S317,118.38,315.66,118.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.51,113.2a13,13,0,0,1-1.4.11,2.22,2.22,0,0,1-1.44-.15.72.72,0,0,1-.26-.85,1.8,1.8,0,0,1,1.57-.9,2.63,2.63,0,0,1,1.85.42A.77.77,0,0,1,323.51,113.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.35,116.67a11.68,11.68,0,0,0,1.12-.84c.43-.33.8-.54,1-1.08a.72.72,0,0,0-.38-.79,1.76,1.76,0,0,0-1.77.37,2.62,2.62,0,0,0-1.1,1.54A.77.77,0,0,0,313.35,116.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.44,125.28c-.14.32-.25.74-.59.91a2.81,2.81,0,0,1-1.15.19,0,0,0,0,0,0,.07,1.44,1.44,0,0,0,1.46,0,1.14,1.14,0,0,0,.41-1.19C327.54,125.22,327.46,125.23,327.44,125.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,122.78a3.63,3.63,0,0,1-1.61,2.4,4.48,4.48,0,0,1-1.17.55l-.24.06-.23.06a.27.27,0,0,1-.29-.14h0l0-.11h0l0-.08c-.33-.74-.73-1.92-.73-1.92-.22.25-1.36,1.46-1.5,1.06a54.07,54.07,0,0,1-2.87-10.6.1.1,0,0,1,.19,0c1.23,3.16,1.9,6.52,3.09,9.71a6.62,6.62,0,0,1,1.37-1.13c.12,0,.73,2.29.91,2.61l0,0a5,5,0,0,0,3-2.49C325.12,122.64,325.23,122.68,325.2,122.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.18,115.92c-2.88.53-5.25-6.45-5.25-6.45s-3.87-.16-7.05-6.16c0,0-.29,7-12.23,9.43a10.37,10.37,0,0,1-1.13-6.26,43.45,43.45,0,0,0-.86,7.14s-5.89-8.64,1.15-14.69c2.8-2.4,7.82-3.75,16.53-2.51,0,0,0-5,1-4.65s.77,5,.77,5,2.95-2.1,3.73-1.59-2.22,2.3-2.22,2.3a6.86,6.86,0,0,1,6.63,6C339.25,109.13,338.61,115.66,337.18,115.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,97.74a6.27,6.27,0,0,1,7.73,3,11.66,11.66,0,0,1,.94,5.19,22.09,22.09,0,0,1-.89,5.48c0,.1-.18,0-.15-.06a16.5,16.5,0,0,0,.5-5,15.67,15.67,0,0,0-.77-4.81,6,6,0,0,0-7.31-3.61C330.66,97.94,330.61,97.78,330.7,97.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.85,95.19a24.17,24.17,0,0,1,6.3.22,17.58,17.58,0,0,1,5.73,1.71c.09,0,0,.19-.06.15A32,32,0,0,0,318.46,96c-3.54.14-7.36,1.4-9,4.84,0,.06-.11,0-.09,0C310.7,97.29,314.37,95.58,317.85,95.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.47,114.64s1-6,3.54-5.89,3.38,7.79,1.42,9.84a2.72,2.72,0,0,1-3.9.28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,111s.07,0,.05.06c-1.35,1.5-1.48,3.48-1.31,5.39a1.49,1.49,0,0,1,1.83-1.34c.06,0,.05.1,0,.11a1.68,1.68,0,0,0-1.4,1.32,8.21,8.21,0,0,0-.14,1.72c0,.19-.32.24-.34,0v0C335.78,116.08,336,112.28,338.18,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14,141.8c5.07,17.76,8.29,51.21,5.72,57.29-2.28,5.38-19.41,17.88-29.26,24.56-3.21,2.18-18.75-22.38-15.2-24.52,4.84-2.9,22.19-14.37,22.61-15.61s2-26.38,4.67-40.79C348.08,129.67,355.23,135.08,357.14,141.8Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.62,228.09c2.43,2.48,8-4,8-4a6.42,6.42,0,0,0,.59,4.31c1.34,2.27,5.48,1.17,5.48,1.17a7.94,7.94,0,0,0,1.36,4.44c1.5,2,5.84,1.53,5.84,1.53a6.91,6.91,0,0,0,3.65,3.15c4.22,1.38,9.13-3.36,12.75-5.7a52,52,0,0,0,11.21-10.52L320,198.73s-20.64,5.14-24.11,8.91C292.92,210.81,281.92,224.31,285.62,228.09Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,224c2.29-4.11,5.57-7.68,8.76-11.08.07-.07.19,0,.12.11-3.22,3.35-5.62,7.64-8.7,11.11A.12.12,0,0,1,293.63,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,229.21a11.85,11.85,0,0,1,2.15-2.38c.82-.79,1.66-1.57,2.5-2.33q2.55-2.3,5.2-4.45c.08-.06.19,0,.11.11-1.68,1.53-3.34,3.08-5,4.67-.81.8-1.62,1.6-2.42,2.41a14.84,14.84,0,0,1-2.36,2.19A.16.16,0,0,1,299.57,229.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,235.45a8.63,8.63,0,0,1,2.05-2l2.35-2c1.56-1.38,3.11-2.76,4.62-4.18a.08.08,0,0,1,.12.11c-1.53,1.46-3,2.94-4.57,4.39-.75.71-1.51,1.41-2.28,2.11a8,8,0,0,1-2.23,1.74S307,235.49,307,235.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.18,182.8l-27.57.34s3.54-30.39,7.35-43.62c3.2-11.12,9.86-10.1,13.52,4.26C362.94,157.36,366.18,182.8,366.18,182.8Z",
    style: {
      fill: "#226BF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.68,179l-.09-.15a8.8,8.8,0,0,1-1.85-5.55c0-.63.08-1.77.83-2C365,174.36,365.4,177,365.68,179Zm-21.45-25.35a10.57,10.57,0,0,1,3.7-4.49c.84-.65,2.44-2,3.07-.4a3,3,0,0,1-.12,1.9,10.25,10.25,0,0,1-1.65,3.18c-.87,1.2-2.34,2.8-4,2.61S343.81,154.81,344.23,153.67Zm9.81-8.4a10.05,10.05,0,0,1,2-5.92c.65-.75,1.44-1,2.08-.57s1,1.54,1.18,2.38a10.71,10.71,0,0,1-.76,6c-.53,1.18-1.48,2.83-3,2.56C353.55,149.4,353.93,146.68,354,145.27Zm-7.77,1.22c-.91-.64-.18-3.3.55-4.58.94-1.64,2.55-3.52,4-2.92.74.3.95,2.24-.5,4.78C349,146.12,347,147,346.27,146.49Zm-1.63,28.22c-.15.73-.56,2.06-1.4,2.33s-1.19-.55-1.34-1.18a9.2,9.2,0,0,1-.22-3c.06-1.35.51-2.61,1.68-3C345.68,169.14,344.85,173.76,344.64,174.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,177.4a42.65,42.65,0,0,1,5.28-.4c1.82-.1,3.64-.13,5.46-.17s9.06.08,10.87.11c.08,0,.07.14,0,.15-1.82.1-9.05.51-10.83.54s-3.56.08-5.34.05a46.44,46.44,0,0,1-5.42-.19S342.24,177.41,342.29,177.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,148.75c.66,2.8,1.25,5.62,1.81,8.44s1.07,5.66,1.58,8.49.94,5.67,1.36,8.52c.22,1.42.39,2.85.55,4.28s.32,2.87.36,4.32v.12h-.12l-2.78-.08,2.77-.15-.11.12c-.33-2.85-.83-5.68-1.31-8.51l-1.44-8.5c-.45-2.84-1-5.67-1.4-8.51S361,151.61,360.63,148.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.87,150.27a9.74,9.74,0,0,1,.36,2.62,8.64,8.64,0,0,1-.36,2.62,23.24,23.24,0,0,1-.14-2.62A17.85,17.85,0,0,1,361.87,150.27Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.bbb8030bb21dfae3e6fb1b7d4138795d.svg";
export { ForwardRef as ReactComponent };